module.exports = __webpack_public_path__ + "static/media/Azerbaijan.2a4daed1.png";